module.exports = __webpack_public_path__ + "static/media/1st-8th Floor.165b7737.webp";